import { ReduxService } from 'dashboard-services/services';

import { basicAIToolsActions } from 'actions/modules/aiTools';

export const aiToolsCommonInitialState = {
  currentVersion: {
    index: 1,
    isPreviousVersion: false
  },
  prompt: undefined,
  versions: [],

  inputFile: undefined,
  inputFileRaw: undefined,
  inputFileInfo: undefined,

  outputFile: undefined,
  outputFileInfo: undefined,
  outputFileRaw: undefined,
  
  isSaveDialogOpen: false
}

export default (state = aiToolsCommonInitialState, action) => {
  switch (action.type) {
    case basicAIToolsActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case basicAIToolsActions.ADD_TO_VERSIONS:
      return ReduxService.updateObject(state, { versions: state.versions.add(action.item) })
    case basicAIToolsActions.CLEAR:
      return aiToolsCommonInitialState;
    default:
      return state;
  }
}